"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.StandalonePageableList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_components_1 = require("@codametrix/ui-components");
var StandalonePageableList = function (props) {
    var pageable = props.sortablePageable.pageableDefinition;
    var onPaginationClick = function (action) {
        var _a = props.sortablePageable, pageable = _a.pageableDefinition, sortableOptions = _a.sortableOptions, filterableOptions = _a.filterableOptions;
        var retAction = {
            pageableDefinition: __assign(__assign({}, pageable), { pageable: __assign(__assign({}, pageable.pageable), { pageNumber: action.index, pageSize: action.size }) }),
            sortableOptions: sortableOptions,
            filterableOptions: filterableOptions
        };
        props.list(retAction);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "standalone-pageable" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "pageable-list" }, { children: props.children })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "pagination-controls" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Pagination, { pageable: pageable, onSelect: onPaginationClick, theme: props.theme }) }))] })));
};
exports.StandalonePageableList = StandalonePageableList;
exports.StandalonePageableList.defaultProps = {
    list: function (options) { }
};
exports.StandalonePageableList.displayName = 'StandalonePageableList';
//# sourceMappingURL=standalone-pageable-list.js.map